import React from 'react';
import QuizIcon from '@mui/icons-material/Quiz';
import MenuItem from '../MenuItem';
import SidebarMenuItem from '../SidebarMenuItem';

interface HelpMenuProps {
  navOpen: boolean;
  bigDevice: boolean;
  // eslint-disable-next-line no-unused-vars
  onRouteSelected: (menuItem: MenuItem) => void;
}

const HelpMenuItem = (props: HelpMenuProps) => {
  const { bigDevice, navOpen, onRouteSelected } = props;
  return (
    <SidebarMenuItem
      bigDevice={bigDevice}
      navOpen={navOpen}
      menuItem={{
        title: 'Help Center',
        leftIcon: <QuizIcon />,
        route: 'https://help.totaleto.com/hc/en-us',
      }}
      onRouteSelected={onRouteSelected}
    />
  );
};

export default HelpMenuItem;
